(function () {
  if (customElements.get('pb-recently-viewed-products')) return;

  class PbRecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.pb-recently-viewed-section');
      this.grid = this.querySelector('[data-recently-viewed-grid]');
      this.empty = this.querySelector('[data-recently-viewed-empty]');
      this.clearButton = this.querySelector('[data-recently-viewed-clear]');
      this.storageKey = this.dataset.storageKey || 'pb_recently_viewed_products_v1';
      this.maxItems = this.toNumber(this.dataset.maxItems, 4);
      this.storageLimit = this.toNumber(this.dataset.storageLimit, 12);
      this.showCurrent = this.toBoolean(this.dataset.showCurrent);
      this.showVendor = this.toBoolean(this.dataset.showVendor);
      this.showPrice = this.toBoolean(this.dataset.showPrice);
      this.currentProduct = this.readCurrentProduct();

      this.clearButton?.addEventListener('click', () => {
        this.writeProducts([]);
        this.render();
      });

      if (this.currentProduct) {
        this.saveCurrentProduct(this.currentProduct);
      }

      this.render();
    }

    toNumber(value, fallback) {
      const number = Number.parseInt(value, 10);
      return Number.isFinite(number) && number > 0 ? number : fallback;
    }

    toBoolean(value) {
      return value === true || value === 'true';
    }

    readCurrentProduct() {
      const script = this.querySelector('[data-recently-viewed-current]');
      if (!script?.textContent) return null;

      try {
        const product = JSON.parse(script.textContent);
        return product && product.id && product.handle ? product : null;
      } catch (error) {
        return null;
      }
    }

    readProducts() {
      try {
        const products = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        return Array.isArray(products) ? products.filter((product) => product && product.id && product.handle) : [];
      } catch (error) {
        return [];
      }
    }

    writeProducts(products) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(products.slice(0, this.storageLimit)));
      } catch (error) {
        // Browsing storage can fail in private modes; the section should simply stay quiet.
      }
    }

    saveCurrentProduct(currentProduct) {
      const products = this.readProducts().filter(
        (product) => String(product.id) !== String(currentProduct.id) && product.handle !== currentProduct.handle
      );

      this.writeProducts([{ ...currentProduct, viewedAt: String(Date.now()) }, ...products]);
    }

    getRenderableProducts() {
      let products = this.readProducts();

      if (!this.showCurrent && this.currentProduct) {
        products = products.filter(
          (product) =>
            String(product.id) !== String(this.currentProduct.id) && product.handle !== this.currentProduct.handle
        );
      }

      return products.slice(0, this.maxItems);
    }

    render() {
      if (!this.grid || !this.section) return;

      const products = this.getRenderableProducts();
      const showEmpty = products.length === 0 && window.Shopify?.designMode;

      this.grid.replaceChildren(...products.map((product) => this.createCard(product)));
      this.grid.hidden = products.length === 0;

      if (this.empty) {
        this.empty.hidden = !showEmpty;
      }

      if (this.clearButton) {
        this.clearButton.hidden = products.length === 0;
      }

      this.section.hidden = products.length === 0 && !showEmpty;
    }

    createCard(product) {
      const item = document.createElement('li');
      item.className = 'pb-recently-viewed-card';

      const link = document.createElement('a');
      link.className = 'pb-recently-viewed-card__link';
      link.href = product.url || `/products/${product.handle}`;
      link.setAttribute('aria-label', product.title || 'View product');

      const imageWrap = document.createElement('span');
      imageWrap.className = 'pb-recently-viewed-card__image';
      imageWrap.setAttribute('aria-hidden', product.image ? 'false' : 'true');

      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = product.imageAlt || product.title || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 640;
        image.height = 640;
        imageWrap.append(image);
      }

      const body = document.createElement('span');
      body.className = 'pb-recently-viewed-card__body';

      if (this.showVendor && product.vendor) {
        const vendor = document.createElement('span');
        vendor.className = 'pb-recently-viewed-card__vendor';
        vendor.textContent = product.vendor;
        body.append(vendor);
      }

      const title = document.createElement('span');
      title.className = 'pb-recently-viewed-card__title';
      title.textContent = product.title || 'Product';
      body.append(title);

      if (this.showPrice && product.price) {
        const priceRow = document.createElement('span');
        priceRow.className = 'pb-recently-viewed-card__price-row';

        const price = document.createElement('span');
        price.className = 'pb-recently-viewed-card__price';
        price.textContent = product.price;
        priceRow.append(price);

        if (product.compareAt) {
          const compare = document.createElement('s');
          compare.className = 'pb-recently-viewed-card__compare';
          compare.textContent = product.compareAt;
          priceRow.append(compare);
        }

        body.append(priceRow);
      }

      link.append(imageWrap, body);
      item.append(link);

      return item;
    }
  }

  customElements.define('pb-recently-viewed-products', PbRecentlyViewedProducts);
})();
